export default __webpack_public_path__ + "static/media/y.96981b4a.jpg";